import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BehaviorSubject, Subject, of, switchMap, takeUntil } from 'rxjs';

import { ConfigResolverService } from './config-resolver.service';

@Directive({
  selector: '[laConfigFormControl]',
  standalone: true,
})
export class ConfigFormControlDirective implements OnInit, OnDestroy {
  @Input('laConfigFormControl') formControlId?: string;

  @Input() get portalId() {
    return this.portalId$.value;
  }
  set portalId(value: number | null | undefined) {
    this.portalId$.next(value);
  }
  private portalId$ = new BehaviorSubject<number | null | undefined>(null);

  destroyed = new Subject<void>();

  constructor(
    private control: NgControl,
    private configResolver: ConfigResolverService
  ) {}

  ngOnInit(): void {
    this.listenToDefaultValueChanges();
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  private listenToDefaultValueChanges() {
    this.portalId$
      .asObservable()
      .pipe(
        switchMap((portalId) => {
          if (!this.formControlId) {
            return of(null);
          }
          return this.configResolver.resolveInputDefaultValue(
            this.formControlId,
            portalId
          );
        }),
        takeUntil(this.destroyed)
      )
      .subscribe((defaultValue) => {
        if (defaultValue && !this.control.value && this.control.untouched) {
          this.control.control?.setValue(defaultValue);
        }
      });
  }
}
